module.exports = __webpack_public_path__ + "img/11.765263f9.png";